<div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
  <h2 class="m-0">Edit location</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>
  <mat-dialog-content>
    <div class="content" style="padding-bottom: 40px;
    ">
        <!-- <h1>Offering a wide range of services designed to pamper and rejuvenate.</h1> -->
        <div class="map-holder">
          <div #mapContainer id="map-container" style="height: 350px; width: 100%;"></div>

        </div>
        <div class="map-form-holder">
          <h4>Address</h4>
          <mat-form-field appearance="outline" class="w-100">
            <!-- <h4>Owner phone</h4> -->
            <input
            [(ngModel)]="formattedAddress"

            #autocomplete id="autocomplete" type="text" placeholder="Enter address"
              matInput
              #input
            />
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button
          mat-flat-button
          color="accent"
          (click)="saveLocation()">
        Save
        </button>
      </mat-dialog-actions>